import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// English translations
const en = {
  translation: {
    // Navigation
    nav: {
      signIn: 'Sign In',
      signInWithGoogle: 'Sign in with Google',
      continueAsGuest: 'Continue as Guest',
      getStarted: 'Get Started Free',
      goToDashboard: 'Go to Dashboard',
    },
    // Landing Page
    landing: {
      badge: 'The Most Powerful AI Platform',
      title1: 'The Future of AI',
      title2: 'Is Here',
      subtitle: 'Chat with multiple AI models, generate stunning images, access real-time data, and unlock infinite creative possibilities with JAF AI.',
      startCreating: 'Start Creating Free',
      watchDemo: 'Watch Demo',
      noCreditCard: 'No credit card required',
      liveDemo: 'Live Demo',
      realTimeData: 'Real-time data',
      features: 'Features',
      everythingYouNeed: 'Everything You Need',
      featuresSubtitle: 'The most comprehensive AI platform with cutting-edge features',
      multiModelSupport: 'Multi-Model Support',
      chooseYourAI: 'Choose Your AI',
      chooseAISubtitle: 'Switch between the world\'s most powerful AI models instantly',
      readyToExperience: 'Ready to Experience the Future?',
      joinThousands: 'Join thousands of users who are already creating amazing things with JAF AI.',
      copyright: '© 2025 JAF AI. The most powerful AI platform.',
      or: 'or',
    },
    // Features
    features: {
      aiChat: 'AI Chat',
      aiChatDesc: 'Intelligent conversations powered by multiple cutting-edge AI models.',
      imageGen: 'Image Generation',
      imageGenDesc: 'Create stunning visuals with our advanced AI. 8 style presets included.',
      videoGen: 'Video Generation',
      videoGenDesc: 'Generate AI-powered videos from text descriptions.',
      webSearch: 'Real-time Web Search',
      webSearchDesc: 'Access live weather, crypto prices, news, and exchange rates.',
      voiceInput: 'Voice Input',
      voiceInputDesc: 'Speak to JAF AI using built-in speech recognition.',
      codeExpert: 'Code Expert',
      codeExpertDesc: 'Write, debug, and explain code in 50+ programming languages.',
    },
    // Capabilities badges
    capabilities: {
      liveWebSearch: 'Live Web Search',
      mathCalculations: 'Math Calculations',
      cryptoPrices: 'Crypto Prices',
      weatherData: 'Weather Data',
      multiLanguage: 'Multi-language',
      aiModels: '4 AI Models',
    },
    // AI Models
    models: {
      jafFlash: 'JAF Flash',
      jafFlashDesc: 'Lightning fast responses',
      jafPro: 'JAF Pro',
      jafProDesc: 'Maximum capability',
      jafBalanced: 'JAF Balanced',
      jafBalancedDesc: 'Perfect equilibrium',
      jafCreative: 'JAF Creative',
      jafCreativeDesc: 'Artistic excellence',
      ultraFast: 'Ultra Fast',
      mostPowerful: 'Most Powerful',
      balanced: 'Balanced',
      creative: 'Creative',
    },
    // Stats
    stats: {
      aiModels: 'AI Models',
      possibilities: 'Possibilities',
      languages: 'Languages',
      available: 'Available',
    },
    // Common
    common: {
      loading: 'Loading...',
      error: 'Error',
      success: 'Success',
      cancel: 'Cancel',
      save: 'Save',
      delete: 'Delete',
    },
  },
};

// Arabic translations
const ar = {
  translation: {
    // Navigation
    nav: {
      signIn: 'تسجيل الدخول',
      signInWithGoogle: 'تسجيل الدخول بجوجل',
      continueAsGuest: 'المتابعة كضيف',
      getStarted: 'ابدأ مجاناً',
      goToDashboard: 'الذهاب إلى لوحة التحكم',
    },
    // Landing Page
    landing: {
      badge: 'أقوى منصة ذكاء اصطناعي',
      title1: 'مستقبل الذكاء الاصطناعي',
      title2: 'هنا الآن',
      subtitle: 'تحدث مع نماذج ذكاء اصطناعي متعددة، أنشئ صوراً مذهلة، واحصل على بيانات فورية، وافتح إمكانيات إبداعية لا حدود لها مع JAF AI.',
      startCreating: 'ابدأ الإنشاء مجاناً',
      watchDemo: 'شاهد العرض',
      noCreditCard: 'لا حاجة لبطاقة ائتمان',
      liveDemo: 'عرض مباشر',
      realTimeData: 'بيانات فورية',
      features: 'المميزات',
      everythingYouNeed: 'كل ما تحتاجه',
      featuresSubtitle: 'أشمل منصة ذكاء اصطناعي بأحدث التقنيات',
      multiModelSupport: 'دعم نماذج متعددة',
      chooseYourAI: 'اختر ذكاءك الاصطناعي',
      chooseAISubtitle: 'انتقل بين أقوى نماذج الذكاء الاصطناعي في العالم فوراً',
      readyToExperience: 'مستعد لتجربة المستقبل؟',
      joinThousands: 'انضم إلى آلاف المستخدمين الذين يبدعون أشياء مذهلة مع JAF AI.',
      copyright: '© 2025 JAF AI. أقوى منصة ذكاء اصطناعي.',
      or: 'أو',
    },
    // Features
    features: {
      aiChat: 'محادثة ذكية',
      aiChatDesc: 'محادثات ذكية مدعومة بنماذج ذكاء اصطناعي متطورة.',
      imageGen: 'توليد الصور',
      imageGenDesc: 'أنشئ صوراً مذهلة بالذكاء الاصطناعي. 8 أنماط مضمنة.',
      videoGen: 'توليد الفيديو',
      videoGenDesc: 'أنشئ فيديوهات بالذكاء الاصطناعي من وصف نصي.',
      webSearch: 'بحث ويب فوري',
      webSearchDesc: 'احصل على الطقس وأسعار العملات والأخبار وأسعار الصرف.',
      voiceInput: 'إدخال صوتي',
      voiceInputDesc: 'تحدث إلى JAF AI باستخدام التعرف على الصوت.',
      codeExpert: 'خبير البرمجة',
      codeExpertDesc: 'اكتب وصحح واشرح الكود بأكثر من 50 لغة برمجة.',
    },
    // Capabilities badges
    capabilities: {
      liveWebSearch: 'بحث ويب مباشر',
      mathCalculations: 'حسابات رياضية',
      cryptoPrices: 'أسعار العملات',
      weatherData: 'بيانات الطقس',
      multiLanguage: 'متعدد اللغات',
      aiModels: '4 نماذج ذكاء',
    },
    // AI Models
    models: {
      jafFlash: 'JAF فلاش',
      jafFlashDesc: 'ردود سريعة جداً',
      jafPro: 'JAF برو',
      jafProDesc: 'أقصى قدرة',
      jafBalanced: 'JAF متوازن',
      jafBalancedDesc: 'توازن مثالي',
      jafCreative: 'JAF إبداعي',
      jafCreativeDesc: 'تميز فني',
      ultraFast: 'سريع جداً',
      mostPowerful: 'الأقوى',
      balanced: 'متوازن',
      creative: 'إبداعي',
    },
    // Stats
    stats: {
      aiModels: 'نماذج ذكاء',
      possibilities: 'إمكانيات',
      languages: 'لغة',
      available: 'متاح',
    },
    // Common
    common: {
      loading: 'جاري التحميل...',
      error: 'خطأ',
      success: 'نجاح',
      cancel: 'إلغاء',
      save: 'حفظ',
      delete: 'حذف',
    },
  },
};

// Get saved language or default to English
const savedLang = localStorage.getItem('i18nextLng') || 'en';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en,
      ar,
    },
    lng: savedLang,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Set initial document direction
document.documentElement.dir = savedLang === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = savedLang;

export default i18n;
